import { useState } from "react";
import { format, parseISO, startOfToday } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toDate = (s) => (s ? parseISO(s) : undefined);

export const DatePickerField = ({ label, value, onChange, min, max, testId }) => {
  const [open, setOpen] = useState(false);
  const selected = toDate(value);
  const minDate = toDate(min) || startOfToday();
  const maxDate = toDate(max);
  return (
    <div className="block">
      <span className="text-[10px] uppercase tracking-wider text-gray-400">{label}</span>
      <Popover open={open} onOpenChange={setOpen}>
        <div className="relative mt-1">
          <PopoverTrigger asChild>
            <button type="button" data-testid={testId} className={`w-full h-10 rounded-lg border px-2.5 pr-7 text-left text-[13px] flex items-center gap-1.5 transition-colors ${open ? "border-[var(--navy)] ring-1 ring-[#0b2545]/20" : "border-gray-200 hover:border-gray-300"} ${selected ? "text-[var(--navy)] font-medium" : "text-gray-400"}`}>
              <CalendarDays className="w-3.5 h-3.5 shrink-0 text-[var(--yellow-2)]" />
              <span className="truncate">{selected ? format(selected, "d MMM yy") : "Any date"}</span>
            </button>
          </PopoverTrigger>
          {selected && (
            <button type="button" onClick={() => onChange("")} aria-label={`Clear ${label}`} data-testid={`${testId}-clear`} className="absolute right-1.5 top-1/2 -translate-y-1/2 p-1 rounded-full text-gray-400 hover:text-[var(--red)] hover:bg-gray-100">
              <X className="w-3 h-3" />
            </button>
          )}
        </div>
        <PopoverContent align="start" className="w-auto p-0 z-[200]" data-testid={`${testId}-calendar`}>
          <Calendar
            mode="single"
            selected={selected}
            defaultMonth={selected || minDate}
            onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
            disabled={[{ before: minDate }, ...(maxDate ? [{ after: maxDate }] : [])]}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
